/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import "../styles/ClaimResult.css";
import { ChevronDown, ChevronUp } from "lucide-react";
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import RadarTooltip from "../components/RadarTooltip";
import RadarEvidenceBlock from "../components/RadarEvidenceBox";
import { speechEvidenceData } from "../components/SpeechEvidenceCard";
import SpeechEvidenceCard from "../components/SpeechEvidenceCard";
import AiConfidenceMeter from "../components/AIConfidenceMeter";
import AiSummaryPanel from "../components/AISummaryPanel";
import VoteEvidenceCard from "../components/VoteEvidenceCard";

export default function ClaimResult({
  claim,
  verdict,
  records,
  speech_stats,
  vote_stats,
  counts,
  speechEvidenceData,
  vote_records,
}) {
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [expandedSpeechIndex, setExpandedSpeechIndex] = useState(null);
  const [showExplainer, setShowExplainer] = useState(true);
  const [activeRadarSection, setActiveRadarSection] = useState(null);

  const radarEvidenceData = [
    {
      id: "speech-clarity",
      icon: "🗣️",
      title: "Speech Clarity",
      summary: speech_stats.clarity,
    },
    {
      id: "language-strength",
      icon: "💬",
      title: "Language Strength",
      summary: speech_stats.language_strength,
    },
    {
      id: "context-match",
      icon: "🔍",
      title: "Context Match",
      summary: speech_stats.context_match,
    },
    {
      id: "vote-consistency",
      icon: "🧮",
      title: "Vote Consistency",
      summary: `Consistent votes: ${vote_stats.consistent_vote}, Inconsistent: ${vote_stats.inconsistent_vote}`,
    },
    {
      id: "speech-alignment",
      icon: "📈",
      title: "Speech Alignment Over Time",
      summary: speech_stats.alignment_with_claim,
    },
  ];

  const totalVotes = vote_stats.consistent_vote + vote_stats.inconsistent_vote;

  const toggleRow = (index) => {
    setExpandedIndex(index === expandedIndex ? null : index);
  };

  const toggleSpeech = (index) => {
    setExpandedSpeechIndex(index === expandedSpeechIndex ? null : index);
  };

  const sentimentColor = {
    positive: "#4caf50",
    negative: "#ef5350",
    ambiguous: "#ffb74d",
  };

  const radarData = [
    { subject: "Speech Clarity", A: speech_stats.clarity_score, fullMark: 100 },
    {
      subject: "Language Strength",
      A: speech_stats.language_strength_score,
      fullMark: 100,
    },
    {
      subject: "Context Match",
      A: speech_stats.context_match_score,
      fullMark: 100,
    },
    {
      subject: "Vote Consistency",
      A: vote_stats.overall_vote_consistency,
      fullMark: 100,
    },
    {
      subject: "Speech Alignment",
      A: speech_stats.alignment_with_claim_score,
      fullMark: 100,
    },
  ];

  return (
    <main className="claim-result-container">
      <section className="claim-result-inner">
        <header className="result-header">
          <h1>
            Claim: <q>{claim}</q>{" "}
            <span className={`verdict ${verdict.toLowerCase()}`}>
              {verdict}
            </span>
          </h1>
          <p className="explanation">
            This claim was analyzed based on relevant parliamentary speeches and
            voting records. Below are the findings.
          </p>

          <button
            className="logic-button"
            onClick={() => setShowExplainer(!showExplainer)}
          >
            {showExplainer ? "Hide Verdict Logic" : "Show Me the Logic"}
          </button>
        </header>

        {showExplainer && (
          <section className="verdict-explainer">
            <AiSummaryPanel radarData={radarData} counts={counts} />

            {radarEvidenceData.map((block) => (
              <RadarEvidenceBlock key={block.id} {...block} />
            ))}

            {activeRadarSection && (
              <div className="radar-explainer">
                <h4>{activeRadarSection}</h4>
                <p>
                  {activeRadarSection === "Speech Clarity"
                    ? "Measures how clearly the AI interpreted key points in speeches."
                    : activeRadarSection === "Language Strength"
                    ? "Represents the emphasis and assertiveness in the political language used."
                    : activeRadarSection === "Context Match"
                    ? "Assesses how well the speech matches the claim's context."
                    : activeRadarSection === "Vote Consistency"
                    ? "Reflects how often the politician's votes align with the AI-determined position."
                    : activeRadarSection === "Speech Alignment"
                    ? "Proportion of speeches supporting the claim sentiment."
                    : ""}
                </p>
              </div>
            )}
          </section>
        )}

        {speechEvidenceData.length > 0 && (
          <>
            <h2>💬 Speech Extract</h2>
            {speechEvidenceData.map((item, index) => (
              <SpeechEvidenceCard key={index} {...item} />
            ))}
          </>
        )}

        {vote_records.length > 0 && (
          <>
            <h2>📜 Voting Records</h2>
            {vote_records.map((item, index) => (
              <VoteEvidenceCard key={index} {...item} />
            ))}
          </>
        )}

        {/* <section className="speech-timeline">
          <h2>🗣️ Speech Timeline</h2>
          <div className="timeline-wrapper">
            {stats.timeline.map((speech, idx) => (
              <div
                className={`timeline-event ${expandedSpeechIndex === idx ? 'expanded' : ''}`}
                key={idx}
                onClick={() => toggleSpeech(idx)}
              >
                <div
                  className="timeline-bullet"
                  style={{ backgroundColor: sentimentColor[speech.sentiment] }}
                ></div>
                <div className="timeline-content">
                  <span className="timeline-date">{new Date(speech.date).toLocaleDateString()}</span>
                  <h5>{speech.bill}</h5>
                  <p className="timeline-excerpt">
                    {expandedSpeechIndex === idx ? speech.excerpt : `${speech.excerpt.slice(0, 80)}...`}
                  </p>
                  <div className="speech-sentiment-label">
                    Sentiment: <strong style={{ color: sentimentColor[speech.sentiment] }}>{speech.sentiment.toUpperCase()}</strong>
                  </div>
                  <div className="timeline-toggle">
                    {expandedSpeechIndex === idx ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section> */}
      </section>
    </main>
  );
}
